import * as S from "./Link.style";

const Link = (props) => <S.Link variant="body2" {...props} />;

export default Link;
